import { howItWorksSteps } from '@/mocks/homeData';

export default function HowItWorks() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 bg-accent-50 text-accent-600 text-xs font-semibold rounded-full mb-3">
            How It Works
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-3">
            Making Giving <span className="gradient-text">Simple & Transparent</span>
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            Five simple steps to create lasting impact. Your generosity, our transparency.
          </p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-1/2 left-[10%] right-[10%] h-0.5 bg-gradient-to-r from-primary-200 via-accent-200 to-secondary-200 -translate-y-1/2"></div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 md:gap-4">
            {howItWorksSteps.map((step, index) => (
              <div key={index} className="flex flex-col items-center text-center relative group">
                <div className="w-16 h-16 rounded-full bg-background-50 border-2 border-primary-200 flex items-center justify-center mb-4 relative z-10 group-hover:border-primary-400 group-hover:scale-110 transition-all duration-300">
                  <i className={`${step.icon} text-primary-500 text-2xl group-hover:text-primary-600 transition-colors`}></i>
                  <span className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-primary-500 text-white text-[11px] font-bold flex items-center justify-center">
                    {step.step}
                  </span>
                </div>
                <h4 className="font-heading text-base font-bold text-foreground-950 mb-1.5">{step.title}</h4>
                <p className="text-foreground-500 text-xs leading-relaxed">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}